enum UsageTypes {
  RESIDENTIAL = 'residential',
  COMMERCIAL = 'mixed_greater_than_33_percent',
  MIXED = 'mixed',
  NOT_PRESENT = 'not_present',
}

export default UsageTypes;
